<template>
  <div>
    <div>
      <v-card
        style="background-color: transparent; border-radius: 15px"
        elevation="1"
      >
        <v-card-text>
          <v-container>
            <v-row
              dense
              class="mt-9"
              v-if="loading"
              alig="center"
              justify="center"
            >
              <v-progress-circular indeterminate></v-progress-circular>
            </v-row>
          </v-container>
          <v-container v-if="!loading && content.length === 0">
            <v-row
              dense
              class="mt-9"
              v-if="loading"
              alig="center"
              justify="center"
            >
              <span>Ocorreu um problema ao carregar o curso</span>
            </v-row>
          </v-container>
          <v-container v-else>
            <template>
              <v-row
                dense
                class="mt-9"
                justify="center"
                style="margin-top: 5vh"
              >
                <v-col
                  v-for="(item, index) in content"
                  :key="index"
                  class="d-flex align-center justify-center pa-2"
                  cols="12"
                  md="4"
                >
                  <CourseCard
                    :item="item"
                    @toCourse="goToCourse(item.id)"
                    :moduleColor="'secondary-400'"
                    :moduleText="'Módulo'"
                  />
                </v-col>
              </v-row>
            </template>
          </v-container>
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>
<script>
import pitchPartnerApi from "@/shared/pitchPartnerApi";
import CourseCard from "@/components/connect/course/CourseCard.vue";

export default {
  name: "CourseIndex",
  components: {
    CourseCard,
  },
  created() {
    pitchPartnerApi.listCourseContent().then((res) => {
      this.content = res.data.content;
      this.count = res.data.count;
      this.loading = false;
    });
  },
  data() {
    return {
      loading: true,
      content: [],
      count: 0,
    };
  },
  methods: {
    goToCourse(id) {
      this.$router.push({
        path: "/connect/professor/curso/" + id,
        params: { id },
      });
    },
  },
};
</script>
